import {observer} from "mobx-react";
import Grid from "@mui/material/Unstable_Grid2";
import {Divider, Typography} from "@mui/material";
import React from "react";
import {useStore} from "../../stores/Store";
import TextImageComponent from "../Misc/TextImageComponent/TextImageComponent";
import martinFreyImage from '../../assets/img/martinfrey.jpg';
import pavelImage from '../../assets/img/pavel.jpg';
import yuriImage from '../../assets/img/yuriy.jpg';

const TeamPage = () => {
    const {LanguageStore} = useStore();
    const {currentLanguageMessages} = LanguageStore;
    
    const findMemberPicture = (name: string) => {
        if(name === 'Martin Frey') return martinFreyImage;
        if(name === 'Павел Зайцев') return pavelImage;
        if(name === 'Юрий Жмодик') return yuriImage;
        return martinFreyImage;
    }
    
    return (
        <Grid container rowSpacing={4} sx={{justifyContent: 'center', pt: 4}}>
            <Grid container xs={12} lg={10} xl={8}>
                <Grid xs={12}>
                    <Typography textAlign={'center'} variant={'h4'}>{currentLanguageMessages.TeamPage.title}</Typography>
                    <Divider />
                </Grid>
                {
                    currentLanguageMessages.TeamPage.teamMembers.map((member, index) => {
                        if((index % 2) > 0){
                            return <TextImageComponent
                                key={index}
                                orderImage={{xs: index, md: index}}
                                orderText={{xs: index+1, md: index+1}}
                                title={member.name}
                                text={member.text}
                                image={findMemberPicture(member.name)}
                            />
                        }    
                        return <TextImageComponent
                            key={index}
                            orderImage={{xs: index, md: index+1}}
                            orderText={{xs: index+1, md: index}}
                            title={member.name}
                            text={member.text}
                            image={findMemberPicture(member.name)}
                        />
                    })
                }
            </Grid>
        </Grid>
    )
} 

export default observer(TeamPage)